import { Action } from '@ngrx/store'
import * as SystemSettingsTypes from './system-settings.types'

export class FetchSystemSettingsRequest implements Action {
  readonly type = SystemSettingsTypes.FETCH_SYSTEM_SETTINGS_REQUEST
  constructor() {}
}

export class FetchSystemSettingsSuccess implements Action {
  readonly type = SystemSettingsTypes.FETCH_SYSTEM_SETTINGS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchSystemSettingsFailure implements Action {
  readonly type = SystemSettingsTypes.FETCH_SYSTEM_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateSystemSettingsRequest implements Action {
  readonly type = SystemSettingsTypes.UPDATE_SYSTEM_SETTINGS_REQUEST
  constructor(public payload: any) {}
}

export class UpdateSystemSettingsSuccess implements Action {
  readonly type = SystemSettingsTypes.UPDATE_SYSTEM_SETTINGS_SUCCESS
  constructor() {}
}

export class UpdateSystemSettingsFailure implements Action {
  readonly type = SystemSettingsTypes.UPDATE_SYSTEM_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = SystemSettingsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = SystemSettingsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | FetchSystemSettingsSuccess
  | FetchSystemSettingsFailure
  | FetchSystemSettingsRequest
  | UpdateSystemSettingsRequest
  | UpdateSystemSettingsSuccess
  | UpdateSystemSettingsFailure
  | SetDefaultData
  | UpdateField
